// @flow
import React from 'react';
import ContentLoader from 'react-content-loader';
import './WhiteConfirmation.scss';

const ns = 'opt-in-out-loader';

const OptInOutLoader = () => {
  return (
    <ContentLoader className={`${ns} mb-4`} height={40}>
      <rect className={`${ns}__placeholder-rect-label`} />
      <rect className={`${ns}__placeholder-rect-button`} />
    </ContentLoader>
  );
};

export default OptInOutLoader;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/components/WhiteConfirmation/OptInOutLoader.js